<template>
  <el-dialog
    width="700px"
    :show-close="false"
    :visible.sync="visible"
    destroy-on-close
    :close-on-click-modal="false"
  >
    <!-- 上传窗口 -->
    <div v-if="step==1" class="import-product-dialog">
      <p class="dialog-head">Import products with Excel</p>
      <el-divider></el-divider>

      <div class="title-info">
        <span class="brand-title">Brand</span>
        <el-select
          v-model="brandId"
          clearable
          placeholder="Please select the brand of the imported product"
          remote
          filterable
          reserve-keyword
          :remote-method="loadBrands"
          style="width: 490px"
        >
          <el-option
            v-for="item in brandOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <p style="margin-top: 30px">Download the template and fill in the product information according to the
          specifications</p>
        <el-button type="text" @click="download()">Product import template.xls</el-button>
      </div>
      <div class="upload-info">
        <el-upload
          class="upload-demo"
          accept=".xlsx, .xls"
          :headers="headers"
          :on-success="handelSuccess"
          :on-progress="handelProgress"
          :show-file-list="false"
          drag
          :data="{'brandId':brandId}"
          :before-upload="handleBeforeUpload"
          :action="uploadApi"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">or drop file to upload，or&nbsp;<em>click upload</em></div>
          <div class="el-upload__tip" slot="tip">Supports .xlsx, .xls, format files-the size may not exceed 10M</div>
        </el-upload>

      </div>
      <div class="btn">
        <div class="submit">Submit</div>
        <div class="cancel" @click="visible = false">Cancel</div>
      </div>
    </div>

    <!-- 格式校验中 -->
    <div v-else-if="step==2" class="check-format">
      <div v-loading="true"></div>
      <p>{{ isCheckData ? 'Validation format' : 'Importing product' }}</p>
      <div v-if="isCheckData">Format validation may take a while uploaded-please do not operate the current page</div>
      <div v-else>It may take a while for the product to be uploaded - please do not operate the current page</div>

    </div>

    <!-- 结果 -->
    <div v-else-if="step==3" class="result">
      <!-- 校验文件结果 -->
      <template v-if="isCheckData">
        <p>Template validation format</p>
        <p>Total <span>{{ uploadCheckObj['spuCount'] | numberValueFormat }}</span> SPUs format valid action,
          <span>{{ uploadCheckObj['successCount'] | numberValueFormat }} </span> successful,
          <span>{{ uploadCheckObj['failureCount'] | numberValueFormat }} </span> failed,
          <span>{{ uploadCheckObj['repeatCount'] | numberValueFormat }} </span> repetitions;</p>
        <p class="submit" v-if="uploadCheckObj['checkFailureUrl']" @click="download(uploadCheckObj['checkFailureUrl'])">
          Download failed product data</p>
        <div class="btn">
          <div class="cancel" @click="visible = false">Cancel</div>
          <div class="submit" v-if="uploadCheckObj['checkSuccessUrl']" @click="importSpuData">Upload verified products
          </div>
        </div>
      </template>
      <!-- 导入结果 -->
      <template v-else>
        <p>Product Import result</p>
        <p>Total
          <span>{{ uploadObj['spuCount'] | numberValueFormat }}</span> SPUs uploaded,
          <span>{{ uploadObj['spuUploadSuccessCount'] | numberValueFormat }}</span> successes,
          <span>{{ uploadObj['spuUploadFailureCount'] | numberValueFormat }}</span> failures,
          <span>{{ uploadObj['spuUpdateCount'] | numberValueFormat }}</span> updates,
          <span>{{ uploadObj['spuNewCount'] | numberValueFormat }}</span> new
        </p>
        <p @click="download(uploadObj['uploadResultUrl'] )">Download import result</p>
        <p>After the goods are approved, they will be displayed on the ShopVidi website</p>
        <div class="btn">
          <div class="submit" @click="visible = false">Ok</div>
        </div>
      </template>
    </div>

    <!-- 超时 -->
    <div v-else-if="step==504" class="time-out">
      <p><i class="el-icon-warning-outline"></i></p>
      <p>Upload Network Timeout, please re-upload</p>
      <div class="btn">
        <div class="submit" @click="visible = false">Ok</div>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import {getAction, putAction, downloadStaticFile} from '@/api/manage.js'
import Vue from 'vue'
import qs from 'qs'
import {postAction} from "../../api/manage";

export default {
  name: 'import-product',
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      step: 1,
      isCheckData: false,
      basePath: process.env.API_URL,
      uploadApi: '',
      brandManagementMode: Vue.ls.get('userInfo').supplierManagementModel,
      headers: {
        'x-access-token': Vue.ls.get('token')
      },
      /* 校验结果 */
      uploadCheckObj: {},
      /* 导入结果 */
      uploadObj: {},
      brandOptions: [],
      brandId: '',
      userSource:Vue.ls.get('userInfo').userSource,//2公有品牌 3私有品牌

    }
  },
  created() {
    this.loadBrands()
  },
  methods: {
    show() {
      this.brandId = ''
      this.step = 1
      this.visible = true
    },

    // 获取品牌
    loadBrands(name) {
      const userInfo = this.$ls.get('userInfo')
      const supplierId = userInfo.id
      const brandName = name || ''
      getAction(`/v0.2/brands/suppliers/${supplierId}/brands?brandName=${brandName}`).then(res => {
        if (res.success) {
          this.brandOptions = res.result.map(e => {
            const status = e.isDeleted === 0 ? 'Active' : 'Inactive'
            return {
              label: e.brandName + '-' + status,
              value: e.id
            }
          })
        }
      }).catch(() => {
      })
    },
    // 上传文件前验证brandId
    handleBeforeUpload() {
      if (!this.brandId) {
        this.$message.info('Please select the brand of the imported product')
        return false
      }

      return new Promise((resolve) => {
        this.$nextTick(() => {
          this.uploadApi = this.basePath + `product/api/v0.2/suppliers/${Vue.ls.get('userInfo').id}/brands/${this.brandId}/products/verify`
          resolve();
        })
      })

      return true
    },
    download(url) {
      if (!url) {

        let staticUrl = ""
        //公有品牌入驻
        let pubilcBrandSettle="https://master-shopvidi.s3.amazonaws.com/Brand-import-product/Supplier-product+import+form.xlsx"
        //私有品牌入驻
        let privateBrandSettle="https://master-shopvidi.s3.amazonaws.com/Brand-import-product/Wholesale-Product+Import+form.xlsx"

        // 自营
        if (this.brandManagementMode === 2) {
          staticUrl = 'https://master-shopvidi.s3.amazonaws.com/Brand-import-product/Supplier-Self-operated+product+import+form.xlsx'
        }else{
          staticUrl = (this.userSource == 2 ? pubilcBrandSettle : privateBrandSettle)
        }
        downloadStaticFile(staticUrl)
      } else {
        downloadStaticFile(url)
      }
    },

    handelSuccess(response, file, fileList) {
      this.step = 3
      if (response['success']) {
        this.uploadCheckObj = response['result']
        this.$message.success('Verification completed!')
      } else {
        this.$message.error(response['message'])
      }
    },
    handelProgress(event, file, fileList) {
      this.step = 2
      this.isCheckData = true
    },
    async importSpuData() {
      this.step = 2
      this.isCheckData = false

      let res = await postAction(`product/api/v0.2/suppliers/${Vue.ls.get('userInfo').id}/brands/${this.brandId}/products/${this.uploadCheckObj['id']}`)
      if (res['success']) {
        this.uploadObj = res['result']
        this.step = 3
      } else {
        this.visible = false
        this.$message.error(res['message'])
      }
    }
  },
  filters: {
    numberValueFormat: (value) => {
      return !value ? 0 : value
    }
  }
}
</script>

<style lang="less" scoped>

.import-product-dialog {
  .dialog-head {
    color: #262B2F;
    font-family: Satoshi-Bold;
    padding: 15px 15px 0px;
    font-size: 16px;
  }

  .title-info {
    padding: 30px 30px 0 30px;

    .brand-title {
      color: #262B2F;
      font-family: Satoshi-Bold;
      margin-right: 10px;
    }
  }

  .upload-info, .btn {
    margin: 30px 30px 0;
    padding: 20px 0
  }

  .upload-info {
    border: 1px dotted #707070;
    text-align: center;
  }

}

.btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-bottom: 30px;

  div {
    width: 120px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    cursor: pointer;
  }

  .submit {
    background: #000000;
    color: #ffffff;
  }

  .cancel {
    border: 1px solid #000000;
    margin-left: 20px;
    margin-right: 20px;
  }

}

.check-format {
  padding: 40px 30px;
  text-align: center;

  div:nth-child(1) {
    width: 40px;
    height: 40px;
    margin: 0 auto;

  }

  div:nth-child(3) {
    color: #8F8F8F;
    margin-top: 30px;
  }

  p {
    font-family: Satoshi-Bold;
    margin-top: 30px;
  }
}

.result {
  padding: 40px 30px;
  text-align: center;

  p {
    margin-top: 30px;
  }

  p:nth-child(1) {
    font-family: Satoshi-Bold;
  }

  p:nth-child(2) {
    span:nth-child(1) {
      font-family: Satoshi-Bold
    }

    span:nth-child(2) {
      color: #41B76A;
    }

    span:nth-child(3), span:nth-child(4) {
      color: #F77073;
    }
  }

  p:nth-child(3) {
    color: #F77073;
    text-decoration: underline;
    text-underline-offset: 3px;
    cursor: pointer;
  }

  p:nth-child(4) {
    color: #8F8F8F;
  }

  .btn {
    margin-top: 30px;
    padding-bottom: 0px;

    div {
      width: 180px;
    }
  }

}

.time-out {
  padding: 40px 30px;
  text-align: center;
  margin: 0 auto;

  p {
    margin-bottom: 30px;
  }

  p:nth-child(1) {
    font-size: 50px;
  }

  .btn {
    padding-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/produts/import-products.vue